import type {
  CreateMfaToken,
  PasskeyAuthRequest,
  TokenScope,
} from '@dynamic-labs/sdk-api-core';
import type { AuthenticationResponseJSON } from '@simplewebauthn/browser';

import { getCore } from '../../../../client/core/getCore';
import type { DynamicClient } from '../../../../client/types';
import { createApiClient } from '../../../apiClient';

type ServerAuthenticatePasskeyParams = {
  authentication: AuthenticationResponseJSON;
  /** @deprecated Use `requestedScopes` instead. */
  createMfaToken?: CreateMfaToken;
  requestedScopes?: TokenScope[];
};

export const serverAuthenticatePasskey = async (
  { authentication, createMfaToken, requestedScopes }: ServerAuthenticatePasskeyParams,
  client: DynamicClient
) => {
  const core = getCore(client);
  const apiClient = createApiClient({}, client);

  const response = await apiClient.authenticateMfaPasskeyDevice({
    environmentId: core.environmentId,
    passkeyAuthRequest: {
      ...authentication,
      createMfaToken,
      requestedScopes,
      response: {
        ...authentication.response,
        clientDataJson: authentication.response.clientDataJSON,
      },
    } as PasskeyAuthRequest,
  });

  return response;
};
